import React from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import { useUpdateInternalUser } from 'hooks/api/useUpdateInternalUser'

import { Stack, Typography } from '@mui/material'

import { Modal, Button } from '@repo/ui'

interface ArchiveInternalUserModalProps {
  user: {
    id: string
    email: string
    first_name?: string | null
    last_name?: string | null
  }
  open: boolean
  onClose: () => void
  onArchived?: () => void
}

export const ArchiveInternalUserModal = (props: ArchiveInternalUserModalProps) => {
  const { user, open, onClose, onArchived } = props
  const { open: notification } = useSnackbar()

  const { mutate: updateUser, isPending } = useUpdateInternalUser()

  const handleArchive = () => {
    updateUser(
      { userId: user.id, active: false },
      {
        onSuccess: () => {
          onClose()
          onArchived?.()
        },
        onError: (error: any) => {
          const message = getErrorMessage(error)
          notification({
            type: 'error',
            title: message,
          })
        },
      }
    )
  }

  const userName = user.first_name || user.last_name
    ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
    : user.email

  return (
    <Modal
      title="Archive user"
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button
            disableElevation
            variant="secondary"
            onClick={onClose}
            disabled={isPending}
          >
            Cancel
          </Button>

          <Button
            disableElevation
            variant="primary"
            onClick={handleArchive}
            disabled={isPending}
          >
            {isPending ? 'Archiving...' : 'Archive'}
          </Button>
        </>
      }
    >
      <Stack spacing="16px">
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
          {`Archiving ${userName} deactivates their account and revokes access. Their record is kept. You can reactivate them anytime.`}
        </Typography>
      </Stack>
    </Modal>
  )
}
